import styled from "styled-components";
import { colors } from "../../assets/styles";

export const Container = styled.div`
  box-shadow: ${(props) =>
    props.theme.isDarkTheme ? "0 0 4px 2px #282828" : "0 0 4px 2px #ececec"};
  background-color: ${(props) =>
    props.theme.isDarkTheme ? colors.colorDarkOne : colors.colorWhite};
    border-radius: 2px;
`;
